import { render } from "./App.vue?vue&type=template&id=1b558ffc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1b558ffc&lang=css"

import exportComponent from "/Users/mattbio/dev/gym-buddy-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__